import { all, call, fork, put, takeLatest, getContext } from 'redux-saga/effects';
import { getStudentUserRecord, reinviteUser, resetPassword, resetUniUserMfa } from '../../api/api';
import * as actions from './actions';
import { logout } from '../auth/actions';
import { StudentUserActionTypes } from './types';
import _isTesting from '../../utilities/isTesting';
import { toast } from 'react-toastify';

function* handleGetStudentUser(action: ReturnType<typeof actions.getStudentUserRecord>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetStudent');
      return;
    }
    const { studentId, studentEmail, pathway } = action.payload;

    if (!studentId) {
      throw new Error('Student Id is missing or the value is empty');
    }

    const res = yield call(getStudentUserRecord, idToken, studentId, studentEmail, pathway);
    if (res.name === 'Error') {
      throw new Error(res.stack);
    }
    yield put(actions.getStudentUserRecordSuccess(res));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getStudentUserRecordFailure(err.message));
    } else {
      yield put(actions.getStudentUserRecordFailure('An unknown error occurred.'));
    }
  }
}

function* handleReinviteUser(action: ReturnType<typeof actions.reinviteUser>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleReinviteUser');
      return;
    }
    const { uniId, username, pathway } = action.payload;

    if (!uniId) {
      throw new Error('University Id is missing or the value is empty');
    }

    const response = yield call(reinviteUser, idToken, uniId, username, pathway);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.reinviteUserSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.reinviteUserFailure(err.message));
    } else {
      yield put(actions.reinviteUserFailure('An unknown error occured.'));
    }
  }
}

function* handleResetUser(action: ReturnType<typeof actions.reinviteUser>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleResetUser');
      return;
    }
    const { uniId, username, pathway } = action.payload;

    if (!uniId) {
      throw new Error('University Id is missing or the value is empty');
    }

    const response = yield call(resetPassword, idToken, uniId, username, pathway);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.resetPasswordSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.resetPasswordFailure(err.message));
    } else {
      yield put(actions.resetPasswordFailure('An unknown error occured.'));
    }
  }
}

function* handleResetStudentMfa(action: ReturnType<typeof actions.resetStudentMfaRequest>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleResetStudentMfa');
      return;
    }
    const { s_key, university, pathway } = action.payload;
    const response = yield call(resetUniUserMfa, idToken, s_key!, university!, pathway);
    yield put(actions.resetStudentMfaSuccess(response));
    toast.success(`Multi-factor authentication has successfully been reset`);
  } catch (err) {
    toast.error(`Error during multi-factor authentication reset`);
    if (err instanceof Error) {
      yield put(actions.resetStudentMfaFailure(err.message));
    } else {
      yield put(actions.resetStudentMfaFailure('An unknown error occured.'));
    }
  }
}

function* watchStudentActions() {
  yield takeLatest(StudentUserActionTypes.GET_STUDENT_USER, handleGetStudentUser);
  yield takeLatest(StudentUserActionTypes.REINVITE_USER, handleReinviteUser);
  yield takeLatest(StudentUserActionTypes.RESET_USER, handleResetUser);
  yield takeLatest(StudentUserActionTypes.RESET_STUDENT_MFA_REQUEST, handleResetStudentMfa);
}

function* StudentUserSaga() {
  yield all([fork(watchStudentActions)]);
}

export default StudentUserSaga;
